import { Duration } from 'luxon';
import { OrderPointType } from '../../../dashboard/orders/common/enums/order-point-type';
import { TransitOperator } from '../../enums/transit/transit-operator';
import type { TransitRoute } from '../../interfaces/transit/transit-route';
import { TRAINS } from './trains';
import { TransitFrequencyInterval } from '../../enums/transit/transit-frequency-interval';

export const TRAIN_ROUTES: TransitRoute[] = [
  /* Germany */
  // Freiburg
  {
    uuid: '3f5566d0-782e-4f9e-9ee2-181acb7cc43f',
    type: OrderPointType.FERRY,
    from: TRAINS.freiburg,
    to: TRAINS.novara,
    operator: TransitOperator.RALPIN,
    frequency: { interval: TransitFrequencyInterval.DAY, value: 8 },
    duration: Duration.fromObject({ hours: 11 }).as('seconds'),
  },

  /* Italy */
  // Novara
  {
    uuid: 'f3977c41-cdbc-4b53-9074-3eada646183e',
    type: OrderPointType.FERRY,
    from: TRAINS.novara,
    to: TRAINS.freiburg,
    operator: TransitOperator.RALPIN,
    frequency: { interval: TransitFrequencyInterval.DAY, value: 8 },
    duration: Duration.fromObject({ hours: 12 }).as('seconds'),
  },
] as const;
